import { Box, Typography } from "@mui/material";
import IMAGE from "assets/images/not-found.svg";
import { AnimatedBackground } from "components/ui/customComponents/animatedBackground";

export const NotFoundScreen = () => {
  return (
    <Box
      sx={{
        minHeight: "60vh",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <img src={IMAGE} alt="not-found" />
      <Typography
        variant="h2"
        sx={{ fontWeight: "600", fontSize: "60px", marginY: "20px" }}
      >
        404
      </Typography>
      <Typography variant="body1" sx={{ fontWeight: "500", fontSize: "18px" }}>
        ¡Lo sentimos! La página que estás buscando no existe :(
      </Typography>
      <AnimatedBackground />
    </Box>
  );
};
